module.exports = __webpack_public_path__ + "img/brittleLava.657cf684.png";